// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padding-cvv {
  padding-top: 0.25rem;
}

.cvv-image {
  filter: invert(100%);
}

.scan-card-item {
  border: 1px solid rgb(211, 211, 211);
  margin-top: 0.25rem;
  border-radius: 0.25rem;
}
.scan-card-item img {
  width: 2rem;
}

.scan-btn {
  background: transparent;
  display: flex;
  column-gap: 10px;
  align-items: center;
  color: #000;
  flex: 1;
}
.scan-btn ion-icon {
  color: #000;
  font-size: 2rem;
}
.scan-btn .button-text-position {
  display: flex;
  flex-direction: column;
  text-align: left;
  row-gap: 0.25rem;
}
.scan-btn span {
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/deposit/deposit-creditcard/deposit-creditcard.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;;AAEA;EAEE,oBAAA;AACF;;AAEA;EACE,oCAAA;EACA,mBAAA;EACA,sBAAA;AACF;AAEE;EACE,WAAA;AAAJ;;AAIA;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,OAAA;AADF;AAGE;EACE,WAAA;EACA,eAAA;AADJ;AAIE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,eAAA;AAHJ","sourcesContent":[".padding-cvv {\n  padding-top: .25rem;\n}\n\n.cvv-image {\n  -webkit-filter: invert(100%);\n  filter: invert(100%);\n}\n\n.scan-card-item {\n  border: 1px solid rgba(211, 211, 211, 1);\n  margin-top: .25rem;\n  border-radius: .25rem;\n\n  // display: flex;\n  img {\n    width: 2rem;\n  }\n}\n\n.scan-btn {\n  background: transparent;\n  display: flex;\n  column-gap: 10px;\n  align-items: center;\n  color: #000;\n  flex: 1;\n\n  ion-icon {\n    color: #000;\n    font-size: 2rem;\n  }\n\n  .button-text-position {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    row-gap: .25rem;\n  }\n\n  span {\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
